// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ReactDOMUtils$Showside from "./ReactDOMUtils.bs.js";
function dangerouslySetInnerHtml(elm, html) {
  elm.innerHTML = html;
  Belt_Array.forEach(Belt_Array.keepMap(Belt_Array.map(Array.prototype.slice.call(elm.querySelectorAll("script")), function (prim) {
    return prim;
  }), function (x) {
    return x;
  }), function (oldScriptEl) {
    var newScriptEl = document.createElement("script");
    Belt_Array.forEach(Array.prototype.slice.call(oldScriptEl.attributes), function (attr) {
      newScriptEl.setAttribute(attr.name, attr.value);
    });
    var scriptText = document.createTextNode(oldScriptEl.innerHTML);
    newScriptEl.appendChild(scriptText);
    Caml_option.nullable_to_opt(oldScriptEl.parentNode).replaceChild(newScriptEl, oldScriptEl);
  });
}
function HtmlWithUnsafeJavascriptExecution(Props) {
  var tagOpt = Props.tag;
  var style = Props.style;
  var className = Props.className;
  var children = Props.children;
  var tag = tagOpt !== undefined ? tagOpt : /* Div */0;
  var callback = React.useCallback(function (el) {
    if (!(el == null)) {
      return dangerouslySetInnerHtml(el, children);
    }
  }, []);
  if (tag) {
    var tmp = {
      ref: ReactDOMUtils$Showside.Ref.callbackDomRef(callback)
    };
    if (className !== undefined) {
      tmp.className = Caml_option.valFromOption(className);
    }
    if (style !== undefined) {
      tmp.style = Caml_option.valFromOption(style);
    }
    return React.createElement("p", tmp);
  }
  var tmp$1 = {
    ref: ReactDOMUtils$Showside.Ref.callbackDomRef(callback)
  };
  if (className !== undefined) {
    tmp$1.className = Caml_option.valFromOption(className);
  }
  if (style !== undefined) {
    tmp$1.style = Caml_option.valFromOption(style);
  }
  return React.createElement("div", tmp$1);
}
HtmlWithUnsafeJavascriptExecution.displayName = "HtmlWithUnsafeJavascriptExecution";
var make = HtmlWithUnsafeJavascriptExecution;
export { dangerouslySetInnerHtml, make };
/* react Not a pure module */